import { uniq, resolved } from '@linc-technologies/linced-common/utils/arrays';

export function groupGoalsBySubcategory(goals) {
  // ensure goals are resolved upfront.
  return resolved(goals).reduce((grouped, goal) => {
    let subcategoryLabel = goal.get('subcategory.label') || 'Other';
    let subject = goal.get('subject');
    let subjectType = subject.get('subjectTypeName') || 'Other';
    let subjectPriority = subject.get('subjectTypePriority') || 0;

    // Store subject types with priority for sorting but exclude it later
    let sortingKey = `${subjectPriority}-${subjectType}`;

    if (!grouped[sortingKey]) {
      grouped[sortingKey] = {};
    }
    if (!grouped[sortingKey][subcategoryLabel]) {
      grouped[sortingKey][subcategoryLabel] = [];
    }

    // Add the goal to the grouped structure
    grouped[sortingKey][subcategoryLabel].push(goal);

    return grouped;
  }, {});
}

export function combineGoals(core, prior, future) {
  let combinedGoals = {};
  const coreGoals = core || {};
  const priorGoals = prior || {};
  const futureGoals = future || {};

  // Collect and sort subjects.
  let allSubjects = uniq([
    ...Object.keys(coreGoals),
    ...Object.keys(priorGoals),
    ...Object.keys(futureGoals),
  ]);

  // Sort by numeric priority (extracted from "priority-subjectType")
  allSubjects.sort((a, b) => {
    let [priorityA] = a.split('-').map(Number);
    let [priorityB] = b.split('-').map(Number);
    return priorityA - priorityB;
  });

  allSubjects.forEach((subjectKey) => {
    const parts = subjectKey.split('-');
    const subject = parts.slice(1).join('-');

    if (!subject) {
      return;
    }

    // Get goal collections for this subject
    const coreGoalsBySubject = (coreGoals && coreGoals[subjectKey]) || {};
    const priorGoalsBySubject = (priorGoals && priorGoals[subjectKey]) || {};
    const futureGoalsBySubject = (futureGoals && futureGoals[subjectKey]) || {};

    // Initialise subject entry without priority
    combinedGoals[subject] = {};

    // Get all subcategories for this subject
    let allSubcategories = new Set([
      ...Object.keys(coreGoalsBySubject),
      ...Object.keys(priorGoalsBySubject),
      ...Object.keys(futureGoalsBySubject),
    ]);

    // For each subcategory, collect goals of each type
    allSubcategories.forEach((subcategory) => {
      combinedGoals[subject][subcategory] = {
        priorGoals: priorGoalsBySubject[subcategory] || [],
        coreGoals: coreGoalsBySubject[subcategory] || [],
        futureGoals: futureGoalsBySubject[subcategory] || [],
      };
    });
  });

  return combinedGoals;
}
